import { useState, useRef, forwardRef, ForwardedRef, ReactNode } from 'react'

export interface TokenLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  srcs: string[]
  fallback?: ReactNode
}

const TokenLogo = forwardRef(
  ({ srcs, alt, fallback, ...rest }: TokenLogoProps, ref: ForwardedRef<HTMLImageElement>) => {
    const [, refresh] = useState<number>(0)
    // Using useRef instead of a global object to track bad sources
    const badSrcsRef = useRef<{ [imageSrc: string]: boolean }>({})

    const src: string | undefined = srcs.find((s) => !badSrcsRef.current[s])

    if (src) {
      return (
        <img
          {...rest}
          ref={ref}
          alt={alt}
          src={src}
          onError={() => {
            if (src) badSrcsRef.current[src] = true
            refresh((i) => i + 1)
          }}
        />
      )
    }

    // Return the custom fallback ReactNode when no valid src is found
    return fallback || <div className={'w-[32px] h-[32px] rounded-full bg-gray-500'} />
  },
)

TokenLogo.displayName = 'TokenLogo'

export default TokenLogo
